import { useNavigate } from 'react-router-dom';
import { useHoverPrefetch } from '@/hooks/useHoverPrefetch';

interface Props {
  tmdbId: number;
  seasonNumber: number;
  episodeNumber: number;
  name: string;
  stillPath: string | null;
  isCurrent: boolean;
}

const TMDB_STILL_BASE = 'https://image.tmdb.org/t/p/w300';

export function EpisodeTile({
  tmdbId,
  seasonNumber,
  episodeNumber,
  name,
  stillPath,
  isCurrent,
}: Props): JSX.Element {
  const navigate = useNavigate();
  const cls = `episode-tile${isCurrent ? ' episode-tile--current' : ''}`;
  const label = `S${seasonNumber}:E${episodeNumber} ${name}`;
  // Skip prefetching the episode the user is already watching — the watch
  // page already opened a session for it.
  const prefetchHandlers = useHoverPrefetch(
    { type: 'tv', tmdbId, season: seasonNumber, episode: episodeNumber },
  );
  function go(): void {
    navigate(`/watch/tv/${tmdbId}/${seasonNumber}/${episodeNumber}`);
  }
  return (
    <button
      type="button"
      className={cls}
      onClick={go}
      data-testid={`episode-tile-${seasonNumber}-${episodeNumber}`}
      aria-current={isCurrent ? 'true' : undefined}
      {...(isCurrent ? {} : prefetchHandlers)}
    >
      <div className="episode-tile__thumb">
        {stillPath ? (
          <img src={`${TMDB_STILL_BASE}${stillPath}`} alt="" loading="lazy" />
        ) : (
          <div className="episode-tile__placeholder" aria-hidden="true" />
        )}
      </div>
      <div className="episode-tile__caption" title={label}>{label}</div>
    </button>
  );
}
